import './image-map.scss';

document.addEventListener('DOMContentLoaded', function () {
    const hotspots = document.querySelectorAll('.hotspot-point');
    const overlay = document.getElementById('overlay');

    // Hide all tooltips
    function hideTooltips() {
        document.querySelectorAll('.hotspot-tooltip').forEach(tooltip => {
            tooltip.style.display = 'none';
            tooltip.style.opacity = '0';
        });
    }

    // Create and display a tooltip
    function createTooltip(hotspot) {
        const tooltipId = 'tooltip-' + hotspot.dataset.id;
        const tooltipText = hotspot.dataset.tooltip;
        const contentType = hotspot.dataset.contentType;
        const content = hotspot.dataset.content;
        const link = hotspot.dataset.link;

        // Extract the fill color from the hotspot
        const fillColor = hotspot.getAttribute('fill') || '#034ea1';

        // Remove any existing tooltip
        const existingTooltip = document.getElementById(tooltipId);
        if (existingTooltip) {
            existingTooltip.remove();
        }

        const tooltip = document.createElement('div');
        tooltip.id = tooltipId;
        tooltip.className = 'hotspot-tooltip';

        // Set the background color of the tooltip
        tooltip.style.backgroundColor = fillColor;

        // Create tooltip content based on the content type
        let tooltipContent = `<h3>${tooltipText}</h3>`;
        if (contentType === 'link') {
            if (content) tooltipContent += `<p>${content}</p>`;
            tooltipContent += `<a href="${link}" class="tooltip-link" target="_blank">Learn More</a>`;
        } else if (contentType === 'none') {
            if (content) tooltipContent += `<p>${content}</p>`;
        } else if (contentType === 'modal') {
            tooltipContent += `<button class="open-modal" data-target="${hotspot.dataset.id}">Learn More</button>`;
        }

        tooltip.innerHTML = tooltipContent;
        document.body.appendChild(tooltip);

        // Position tooltip
        positionTooltip(hotspot, tooltip);

        // Add event listeners to keep tooltip visible on hover
        addTooltipEventListeners(hotspot, tooltip);

        return tooltip;
    }

    // Position the tooltip above the hotspot
    function positionTooltip(hotspot, tooltip) {
        const hotspotRect = hotspot.getBoundingClientRect();
        tooltip.style.top = `${window.scrollY + hotspotRect.top - 10}px`;
        tooltip.style.left = `${window.scrollX + hotspotRect.left + (hotspotRect.width / 2)}px`;
        tooltip.style.transform = 'translateY(-100%) translateX(-50%)';
        tooltip.style.display = 'block';
        tooltip.style.opacity = '1';
    }

    // Add event listeners to tooltip
    function addTooltipEventListeners(hotspot, tooltip) {
        tooltip.addEventListener('mouseenter', () => {
            tooltip.style.display = 'block';
            tooltip.style.opacity = '1';
        });

        tooltip.addEventListener('mouseleave', () => {
            tooltip.style.display = 'none';
            tooltip.style.opacity = '0';
        });

        hotspot.addEventListener('mouseleave', () => {
            setTimeout(() => {
                if (!tooltip.matches(':hover')) {
                    tooltip.style.display = 'none';
                    tooltip.style.opacity = '0';
                }
            }, 100);
        });
    }

    // Open modal by ID
    function openModalById(id, fillColor) {
        const modalContainer = document.getElementById('modal-container-' + id);
        const hotspotModal = document.getElementById('modal-' + id);
        if (modalContainer) {
            modalContainer.style.display = 'flex';
            hotspotModal.style.backgroundColor = fillColor; // Set the background color of the modal
            overlay.style.display = 'block';
        }
    }

    // Convert text to a slug format
    function convertToSlug(text) {
        return text
            .toLowerCase()
            .replace(/[^\w\s-]/g, '') // Remove all non-word chars except space and hyphen
            .trim()
            .replace(/\s+/g, '-') // Replace spaces with hyphens
            .replace(/-+/g, '-'); // Replace multiple hyphens with a single hyphen
    }

    // Handle click events for tooltips and modals
    function handleClickEvents(event) {
        if (event.target.classList.contains('open-modal')) {
            const target = event.target.dataset.target;
            const hotspot = document.querySelector(`.hotspot-point[data-id="${target}"]`);
            let fillColor = '#034ea1'; // Default color

            // const fillColor = hotspot ? hotspot.getAttribute('fill') || '#034ea1' : '#034ea1';

            // Check if the open-modal item is inside a div with the class "is-style-accent-dots"
            let parent = event.target.parentElement;
            while (parent) {
                if (parent.classList.contains('is-style-accent-dots')) {
                    fillColor = '#0aaece'; // Specific color for "is-style-accent-dots"
                    break;
                }
                parent = parent.parentElement;
            }

            // If not inside "is-style-accent-dots", use the fill attribute from the hotspot
            if (fillColor === '#034ea1') {
                const hotspot = document.querySelector(`.hotspot-point[data-id="${target}"]`);
                if (hotspot) {
                    fillColor = hotspot.getAttribute('fill') || '#034ea1';
                }
            }
            

            if (target) {
                openModalById(target, fillColor);
            } else {
                const targetFromText = convertToSlug(event.target.textContent);
                openModalById(targetFromText, fillColor);
            }
        }

        if (event.target === overlay) {
            document.querySelectorAll('.hotspot-modal-container').forEach(container => {
                container.style.display = 'none';
            });
            overlay.style.display = 'none';
        }
    }

    // Initialize hotspots
    function initializeHotspots() {
        hotspots.forEach(hotspot => {
            let tooltip = null;

            hotspot.addEventListener('mouseenter', function () {
                tooltip = createTooltip(this);
            });

            document.addEventListener('click', function (event) {
                if (tooltip && !tooltip.contains(event.target) && !hotspot.contains(event.target)) {
                    tooltip.style.display = 'none';
                    tooltip.style.opacity = '0';
                }
            });
        });
    }

    // Initialize modal close buttons
    function initializeModalCloseButtons() {
        document.querySelectorAll('.close-modal').forEach(button => {
            button.addEventListener('click', function () {
                const modal = this.closest('.hotspot-modal-container');
                modal.style.display = 'none';
                overlay.style.display = 'none';
            });
        });
    }

    // Add global event listeners
    function addGlobalEventListeners() {
        window.addEventListener('resize', hideTooltips);
        window.addEventListener('scroll', hideTooltips);
        document.addEventListener('click', handleClickEvents);
    }

    // Initialize all functionalities
    function initialize() {
        initializeHotspots();
        initializeModalCloseButtons();
        addGlobalEventListeners();
    }

    initialize();
});